export const TAG_TARGET_TEMPLATES = 'TARGET_TEMPLATES'
export const TAG_TARGETS = 'TARGETS'
export const TAG_TARGET_GRAPH = 'TARGET_GRAPH'
export default [TAG_TARGETS, TAG_TARGET_TEMPLATES, TAG_TARGET_GRAPH]
